/**
 * @generated SignedSource<<7c319f65829e0ddd5b1a8a0043d31f51>>
 * @relayHash 42fd7a181a3572c512e00d855d84ccd7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 05257f00082c1505d2e9fd0b704170273715da91ce305df6773e3e2ff5cb28f6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AgentContextQuery } from './AgentContextQuery.graphql';

const node: PreloadableConcreteRequest<AgentContextQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "05257f00082c1505d2e9fd0b704170273715da91ce305df6773e3e2ff5cb28f6",
    "metadata": {},
    "name": "AgentContextQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
